module.exports = __webpack_public_path__ + "img/brush-REDBERRIES.3977556a.png";